import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { Row, Col, Form, Spinner } from "react-bootstrap";

import configSubscriptionCode from "../../../image/purchase/add-subscribtion-code.png";
import { userAccessListApi } from "../../../utility/api/apiList";

import { ROUTE_MY_EXPERIMENT } from "../../../routes";

import {
  showSuccessAlert,
  showDangerAlert,
} from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";

import LayoutPurchaseComponent from "../../../components/public/purchase/layoutPurchase";
import ButtonComponent from "../../../components/public/button";
import InputComponent from "../../../components/public/form/input";

import { Wrapper } from "./styledPurchaseSubscriptionCode";

const PurchaseSubscriptionCodeContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetail);

  const schema = yup.object().shape({
    subscription_code: yup.string().required(),
  });

  const {
    register,
    handleSubmit,
    setFocus,
    formState: { isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { isLoading: postCodeLoading, run: subscriptionCodeRun } = useAxios({
    url: userAccessListApi,
    method: "post",
  });

  useEffect(() => {
    scrollToTop();
    document.title = "ثبت کد اشتراک";
    if (!userDetail.isLogin) {
      dispatch(showDangerAlert("لطفا ابتدا وارد شوید"));
    }
    setFocus("subscription_code");
  }, []);

  const onSubmit = (e) => {
    subscriptionCodeRun({ token: e.subscription_code })
      .then(() => {
        dispatch(showSuccessAlert("کد اشتراک شما با موفقیت ثبت شد."));
        setTimeout(() => {
          history.replace({
            pathname: `${userDetail.userRole}/${ROUTE_MY_EXPERIMENT}`,
          });
        }, 3000);
      })
      .catch((error) => {
        if (error.response.data.token[0]) {
          dispatch(showDangerAlert(error.response.data.token[0]));
        } else if (error.response.data?.detail) {
          dispatch(showDangerAlert(error.response.data?.detail));
        }
      });
  };

  return (
    <LayoutPurchaseComponent
      cardTitle="ثبت کد اشتراک"
      rowClassName="w-75 flex-grow-1"
      $width="680px"
      $height="400px"
    >
      <Wrapper className="mt-5 mt-md-0 d-flex flex-column flex-md-row justify-content-around align-items-center">
        <Col className="m-2">
          <Form
            autoComplete="on"
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column justify-content-center align-items-center gap-3"
          >
            <InputComponent
              title="کد اشتراک خود را وارد کنید."
              type="text"
              register={register("subscription_code")}
              containerClass="subscription-input"
            />
            <Row className="w-100 p-0">
              <ButtonComponent
                type="submit"
                className="submit-button col-6 col-md-5 mx-auto"
                disabled={!(isValid && userDetail.isLogin)}
              >
                {postCodeLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                    size="sm"
                  />
                ) : (
                  "ثبت"
                )}
              </ButtonComponent>
            </Row>
          </Form>
        </Col>
        <Col className="m-2">
          <img
            src={configSubscriptionCode}
            alt="ثبت کداشتراک"
            className="image-fluid d-block mx-auto"
          />
        </Col>
      </Wrapper>
    </LayoutPurchaseComponent>
  );
};

export default PurchaseSubscriptionCodeContainer;
